import { Box, Menu, HStack, MenuItem as ChakraMenuItem, MenuButton, MenuList } from '@chakra-ui/react';
import React, { FC, useState } from 'react';
import { Icon } from '../Icon';

import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Item, SubMenuProps } from './types';
import { MenuItem, RegularMenuItem } from './menu-item';

export const SubMenu: FC<SubMenuProps> = ({ menuItem, items, isMenuItemOptions, checkboxChange, selectionCount }) => {
  const [submenuOpen, setSubmenuOpen] = useState<boolean>(false);
  const closeSubmenu = () => {
    if (submenuOpen) {
      setSubmenuOpen(false);
    }
  };
  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  const submenuGroupTitle = (item: Item) => {
    const iconItem: Item = {
      ...item,
      itemConfig: {
        rightIconName: 'chevron-right',
      },
    };
    return (
      <MenuButton
        as={ChakraMenuItem}
        onClick={toggleSubmenu}
        closeOnSelect={false}
        icon={item.itemConfig?.iconName && <Icon iconName={item.itemConfig?.iconName as IconName} />}
      >
        <RegularMenuItem item={iconItem} selectionCount={selectionCount} />
      </MenuButton>
    );
  };
  return (
    <Menu closeOnSelect={false} isOpen={submenuOpen} placement="right-end" onClose={closeSubmenu}>
      {submenuGroupTitle(menuItem)}
      <MenuList>
        {items.map((item, index) => {
          return (
            <MenuItem
              key={`${item.text}-${item.value}-${index}`}
              index={index}
              item={item}
              isMenuItemOptions={isMenuItemOptions}
              checkboxChange={checkboxChange}
            ></MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
